import { render } from "./ServiceEditCustomer.vue?vue&type=template&id=30ff95d6"
import script from "./ServiceEditCustomer.vue?vue&type=script&lang=js"
export * from "./ServiceEditCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__